import React from "react";
import { WidgetProps } from '@rjsf/core';

import DateTimePicker from "../components/DateTimePicker/DateTimePicker";


interface IDatePickerWidgetOptions {
  minDate?: string | true;
  maxDate?: string | true;
}


const DatePickerWidget: React.FC<WidgetProps & { options: IDatePickerWidgetOptions }> = ({
  id,
  disabled,
  value,
  onChange,
  onBlur,
  onFocus,
  options,
  autofocus,
  label,
  schema,
  readonly,
  ...inputProps
}) => {

  // Validate schema
  const schemaFormat = schema.format as "date" | "time" | "date-time";

  const {
    minDate,
    maxDate,
    defaultTimeType
  } = options


  const oneOfValidFormats = schemaFormat && ["date", "time", "date-time"].includes(schemaFormat);

  if (!oneOfValidFormats && options.format) {
    return <div> [DatePickerWidget]: format in uiSchema is depricated, move format from uiSchema to schema  </div>
  };

  if (!oneOfValidFormats) {
    return <div> [DatePickerWidget]: Schema is missing one of valid format ("date" | "time" | "date-time")  </div>
  };

  return (
    <DateTimePicker
      key={id}
      value={value}
      onChange={onChange}
      minDate={minDate === true ? new Date().toISOString() : minDate}
      maxDate={maxDate === true ? new Date().toISOString() : maxDate}

      format={schemaFormat}
    />
  );
}

DatePickerWidget.defaultProps = {
  required: false,
  disabled: false,
};

export default DatePickerWidget;
